import { render, staticRenderFns } from "./EmailResponse.vue?vue&type=template&id=1858ea35&scoped=true&"
import script from "./EmailResponse.vue?vue&type=script&lang=js&"
export * from "./EmailResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858ea35",
  null
  
)

export default component.exports